import React from 'react';
import PropTypes from 'prop-types';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { deleteRates } from '../../utils';
import { DeleteModal, useArray } from './deleteModal';
import useAppContext from '../../../../context/useAppContext';

export default function DeleteActionModal({ objectsToDelete = null, onSave = () => {}, model, rates, showModal = false, ...props }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [{ event, organization }] = useAppContext();
    const _objects = React.useMemo(() => useArray(objectsToDelete), [objectsToDelete]);
    const firstObj = React.useMemo(() => (_objects?.length > 0 ? _objects[0] : null), [_objects]);

    /**
     * Delete rates
     */
    const deleteObjects = React.useCallback(
        objs => {
            deleteRates({
                rateClass: model,
                ratesToDelete: objs,
                rates: rates,
                onDone: () => {
                    onSave();
                    toast.success(t(`ticket.rates.deleteSuccess`));
                },
                toastError: () => {
                    toast.error(t(`ticket.rates.deleteError`));
                },
                organizationId: organization.pk,
                eventId: event?.pk
            });
        },
        [event, organization, model, rates, onSave]
    );

    const handleSubmit = React.useCallback(() => {
        deleteObjects(_objects);
    }, [deleteObjects, _objects]);

    if (_objects.length === 0) {
        return null;
    }

    return (
        <DeleteModal
            show={showModal}
            onSubmit={handleSubmit}
            objectsToDelete={_objects}
            labelTitle={t(`ticket.rates.deleteRateTitle${firstObj?.is_pass_culture ? 'PassCulture' : ''}`, { count: objectsToDelete?.length })}
            labelBody={t(`ticket.rates.deleteRateContent${firstObj?.is_pass_culture ? 'PassCulture' : ''}`, {
                name: firstObj?.rate_template ? firstObj?.rate_template.name : firstObj?.name,
                count: objectsToDelete?.length
            })}
            {...props}
        />
    );
}

DeleteModal.propTypes = {
    objectsToDelete: PropTypes.array, //required
    rates: PropTypes.array.isRequired,
    model: PropTypes.func,
    show: PropTypes.bool,
    onSave: PropTypes.func.isRequired
};
